import styled from 'styled-components';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
import { breakpoints } from '~/src/components/Header/styled';

export const PromoWrapper = styled.div`
    width: 100%;
    flex-direction: column;

    a {
        color: ${COLORS.black};
    }

    @media (max-width: ${breakpoints.tablet}) {
        margin-top: 24px;
    }
`;

export const PromoTitle = styled.div`
    width: 100%;
    font-size: 14px;
    line-height: 1.14;
    white-space: pre-wrap;
    transition: color 0.3s ease;

    &:hover {
        color: ${COLORS.red};
    }
`;

export const PromoImg = styled.div<{ image: string }>`
    width: 100%;
    height: 120px;
    border-radius: 8px;
    overflow: hidden;
    margin: 8px 0;
    background: url(${p => p.image}) center / cover no-repeat;
`;

export const PromoDesc = styled.p`
    font-size: 12px;
    line-height: 1.33;
    color: ${COLORS.darkGrey};
    white-space: pre-wrap;
`;
